import React from "react";
import { components } from "react-select";

const BORDER_COLOR = '#F2F2F2';
const BORDER_COLOR_FOCUS = '#4D5A31';

const ChamadosDropdownIndicator = (props) => (
    <components.DropdownIndicator {...props}>
        <i className="pi pi-chevron-down" style={{ fontSize: '20px', color: props.isFocused ? BORDER_COLOR_FOCUS : '#BCBEC0', transition: 'color 150ms ease' }} />
    </components.DropdownIndicator>
);

const ChamadosClearIndicator = (props) => (
    <components.ClearIndicator {...props}>
        <i className="pi pi-times" style={{ fontSize: '16px', color: "#6c757d" }} />
    </components.ClearIndicator>
);

export const chamadosSelectComponents = {
    DropdownIndicator: ChamadosDropdownIndicator,
    ClearIndicator: ChamadosClearIndicator,
    IndicatorSeparator: () => null,
};

export const chamadosSelectStyles = {
    control: (base, { isDisabled, isFocused }) => ({
        ...base,
        borderRadius: 0,
        border: `4px solid ${isFocused ? BORDER_COLOR_FOCUS : BORDER_COLOR}`,
        boxShadow: 'none',
        minHeight: '52px',
        padding: '2px 6px',
        fontSize: '20px',
        fontFamily: "'Archivo Expanded', sans-serif",
        transition: 'border-color 150ms ease',
        backgroundColor: isDisabled ? 'rgba(178, 178, 178, 0.13)' : base.backgroundColor,
    }),
    menu: (base) => ({ ...base, borderRadius: 0, marginTop: 0, border: `4px solid ${BORDER_COLOR}`, boxShadow: 'none' }),
    menuList: (base) => ({ ...base, borderRadius: 0, paddingTop: 0, paddingBottom: 0 }),
    dropdownIndicator: (base, { isDisabled }) => ({ ...base, display: isDisabled ? 'none' : 'flex', padding: '0 12px' }),
    indicatorSeparator: () => ({ display: 'none' }),
    option: (base, { data, options, isSelected, isFocused }) => ({
        ...base,
        backgroundColor: options.indexOf(data) % 2 === 0 ? '#FFFFFF' : '#EEEFF0',
        borderLeft: (isSelected || isFocused) ? `4px solid ${BORDER_COLOR_FOCUS}` : '4px solid transparent',
        color: '#5B595B',
        fontFamily: "'Archivo Expanded', sans-serif",
    }),
    placeholder: (base) => ({ ...base, color: '#B3B3B3', fontStyle: 'italic', fontFamily: "'Archivo', sans-serif", fontSize: '20px' }),
    singleValue: (base) => ({ ...base, color: '#5B595B', fontFamily: "'Archivo Expanded', sans-serif", fontWeight: 400, fontSize: '19px' }),
    input: (base) => ({ ...base, fontFamily: "'Archivo Expanded', sans-serif", fontWeight: 400, fontSize: '19px', color: '#5B595B' }),
};
